export default __webpack_public_path__ + "static/media/copy.fdc4e1b2.svg";